<div>
	<button class="ficon-arrow-left back-btn" aria-label="back" (click)="back()"></button>
</div>

<section class="content" aria-labelledby="lti-confirmation-title" aria-describedby="lti-confirmation-description">
	<h1 id="lti-confirmation-title" class="title" translate="lti-verification-title"></h1>

	<p id="lti-confirmation-description" class="description" translate="lti-verification-description">.</p>

	<a href="https://support.echo360.com/hc/en-us/sections/38436732050317-Instructors-Owners" target="blank" rel="noopener noreferrer" class="more-info-link primary-btn" translate="lti-verification-information"></a>

	<div class="link-wrapper"><span translate="lti-verification-link-wrapper-click-here"></span> <button type="button" class="proceed-link goreact-btn link-btn" (click)="proceed()" translate="lti-verification-link-wrapper-link" data-cy="proceed-without-lms"></button></div>
</section>
